<template lang="pug">
#Message
  TransitionGroup.messages(name="slide-fade")
    .box-message(v-for="message in messages" :class="message.type" :key="message.id" @click.stop="deleteMessage(message.id)")
      .paragraph {{ message.message }}
</template>

<script>
export default {
  name: 'Message',

  data () {
    return {
      times: 5,
      pressed: 0,
      timeOut: {}
    }
  },

  methods: {
    deleteMessage (id) {
      this.$store.commit('deleteMessage', id)
    }
  },

  computed: {
    messages () {
      return this.$store.state.messages
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/functions.styl'

.messages
  position fixed
  bottom 0
  right 0
  display flex
  flex-direction column
  gap .7em
  justify-content center
  align-items center
  text-align center
  width 45em
  max-width 100%
  z-index 13000
  padding 1em

.box-message
  width 100%
  min-width 300px
  background-color var(--background-principal)
  borderRadius(1em)
  padding 1em 3em 1em 1.5em
  text-align left
  font-size 1em
  position relative
  cursor pointer

.buttons-modal
  margin-top 1.6em
  display flex
  justify-content center

.button-modal
  margin 0 .5em

.box-message.ok
  background-color #21927b
  color white

.box-message.error
  background-color #DE4956
  color white

.box-message .x
  position absolute
  right .3em
  top .1em
  font-size 2.5em
  font-weight 300
  transform rotateZ(45deg)
  display inline
  cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/layout/Message.vue